<app-layout-dialogheader1 [title]="title" [titlesub]="titlesub" mat-dialog-title></app-layout-dialogheader1>

<mat-dialog-content>

<div class="sectionb">

    <mat-progress-bar mode="indeterminate" *ngIf="loadinglist"></mat-progress-bar>
    <app-frms-messagebar #frmsmessagebar *ngIf="alertmessage" [alertmessage]="alertmessage"></app-frms-messagebar>

        <form [formGroup]="myform" class="container-fluid" (ngSubmit)="saveModel()">
            
            <p>Please enter X-OffSet and/or Y-OffSet for selected image.</p>
            <div class="form-group row">
                <label class="col-sm-3 col-form-label" for="offset_x">*Offset X </label>
                <div class="col-sm-3">
                    <input class="form-control form-control-sm" id="offset_x" formControlName="offset_x" type="number" step="1" required
                        placeholder="Enter offset x to move panels in image"
                        [ngClass]="!myform.get('offset_x').valid ? 'is-invalid' :'' ">
                    <div class="invalid-feedback" *ngIf="myform.get('offset_x').hasError('required')">
                        offset x is required 
                    </div>
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-3 col-form-label" for="offset_y">*Offset Y </label>
                <div class="col-sm-3">
                    <input class="form-control form-control-sm" id="offset_y" formControlName="offset_y" type="number" step="1" required
                        placeholder="Enter offset y to move panels in image"
                        [ngClass]="!myform.get('offset_y').valid ? 'is-invalid' :'' ">
                    <div class="invalid-feedback" *ngIf="myform.get('offset_y').hasError('required')">
                        offset y is required 
                    </div>
                </div>
            </div>
        </form>     


</div>

</mat-dialog-content>
<div mat-dialog-actions style="width:100%;" class="justify-content-end">
    <button mat-raised-button type="button" (click)="saveModel()" [disabled]="!isvalid()||submitted"
        class="btn btn-success pull-right"><i class="far fa-save"></i> Save</button>
    <button mat-raised-button mat-dialog-close class="btn pull-right">Close</button>
</div>